import type { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { isValidUlid } from '@/shared/lib/ulid';
import { NotFoundPage } from './NotFoundPage';

interface UlidRouteGuardProps {
  /** Name of the route param to validate (e.g. "botId", "userId"). */
  paramName: string;
  children: ReactNode;
}

/**
 * LOK-1126: Renders `<NotFoundPage>` when the named route param doesn't look
 * like a ULID. Prevents URLs like `/bots/new` (literal "new") from being
 * captured by `:botId` and triggering a misleading "Bot not found" via a
 * doomed API call.
 */
export function UlidRouteGuard({ paramName, children }: UlidRouteGuardProps) {
  const params = useParams();
  const value = params[paramName];
  if (!isValidUlid(value)) {
    return <NotFoundPage />;
  }
  return <>{children}</>;
}
